/**
 * `clawnify servers` — list the org's agent servers. An org can have several
 * (e.g. an agency managing multiple client boxes). This is the top of the
 * discovery tree the FDE walks: servers → `agents` → `sessions`. Backed by
 * GET /servers (org-scoped).
 */

import { api } from "../lib/api.js";

interface ServerRow {
  id: string;
  name: string | null;
  status: string;
  region?: string | null;
}

export async function serversListCommand(): Promise<void> {
  const res = await api.get("/servers");
  if (!res.ok) {
    console.error(`Failed to list servers (${res.status}).`);
    process.exit(1);
  }
  const { servers } = (await res.json()) as { servers: ServerRow[] };
  if (!servers || servers.length === 0) {
    console.log("No servers in this org yet. Provision one at https://app.clawnify.com.");
    return;
  }

  const idW = Math.max(2, ...servers.map((s) => s.id.length));
  const nameW = Math.max(4, ...servers.map((s) => (s.name ?? "").length));
  console.log(`${"ID".padEnd(idW)}  ${"Name".padEnd(nameW)}  ${"Status".padEnd(10)}  Region`);
  console.log(`${"─".repeat(idW)}  ${"─".repeat(nameW)}  ${"─".repeat(10)}  ${"─".repeat(10)}`);
  for (const s of servers) {
    console.log(
      `${s.id.padEnd(idW)}  ${(s.name ?? "").padEnd(nameW)}  ${s.status.padEnd(10)}  ${s.region ?? ""}`,
    );
  }
}
